import { ssFormUtils, ssFormValidationUtils } from '@bit/ui-common.ui-components/ss-utils';

const
{ validationRules } = ssFormValidationUtils,
{ INPUT } = ssFormUtils,
{ isRequired } = validationRules;

export const 
login = {
    title: 'Log In',
    key: 'login',
    formItems: {
        username: {
            label: 'Username',
            type: INPUT,
            rules: [ isRequired ]
        },
        password: {
            label: 'Password',
            type: INPUT,
            rules: [ isRequired ]
        }
    }
},
passwordReset = {
    title: 'Forgot User ID or Password',
    key: 'passwordReset',
    formItems: {
        userIdOrEmail: {
            label: 'User ID or Email',
            type: INPUT,
            rules: [ isRequired ]
        }
    }
};